<template>
  <header :class="{ 'sticky-header': scrollTop > 20 }">
    <div class="container">
      <router-link to="/#welcome" class="logo-box">
        <img class="logo" src="@/assets/logo.png" alt="Logo" />
      </router-link>

      <nav class="flex gap-40 no-mobile">
        <router-link to="/#welcome" class="header-btn">Home</router-link>

        <button
          class="header-btn"
          @mouseenter="showDiscoverSubmenu = true"
          @mouseleave="showDiscoverSubmenu = false"
        >
          Discover
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path
              d="M12 15.0006L7.75732 10.758L9.17154 9.34375L12 12.1722L14.8284 9.34375L16.2426 10.758L12 15.0006Z"
            ></path>
          </svg>
          <transition name="submenu">
            <div class="submenu" v-show="showDiscoverSubmenu">
              <div class="button-bg">
                <router-link to="/#features">Features</router-link>
              </div>
              <div class="button-bg">
                <router-link to="/#solutions">Solutions</router-link>
              </div>
              <div class="button-bg">
                <router-link to="/#products">Products</router-link>
              </div>
              <div class="button-bg">
                <router-link to="/#team">Team</router-link>
              </div>
            </div>
          </transition>
        </button>

        <button
          class="header-btn"
          @mouseenter="showPagesSubmenu = true"
          @mouseleave="showPagesSubmenu = false"
        >
          Pages
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path
              d="M12 15.0006L7.75732 10.758L9.17154 9.34375L12 12.1722L14.8284 9.34375L16.2426 10.758L12 15.0006Z"
            ></path>
          </svg>
          <transition name="submenu">
            <div class="submenu" v-show="showPagesSubmenu">
              <div class="button-bg">
                <router-link to="/about">About Us</router-link>
              </div>
              <div class="button-bg">
                <router-link to="/features">Features</router-link>
              </div>
              <div class="button-bg">
                <router-link to="/faq">FAQ</router-link>
              </div>
              <div class="button-bg">
                <router-link to="/blog">Blog</router-link>
              </div>
            </div>
          </transition>
        </button>

        <router-link to="/contact" class="header-btn">Contact</router-link>
      </nav>
      <router-link to="/products" class="btn-1 margin-la no-mobile"
        >Products</router-link
      >
      <button class="mobile menu-btn" @click="showMobileMenu = !showMobileMenu">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path
            v-if="showMobileMenu"
            d="M10.5859 12L2.79297 4.20706L4.20718 2.79285L12.0001 10.5857L19.793 2.79285L21.2072 4.20706L13.4143 12L21.2072 19.7928L19.793 21.2071L12.0001 13.4142L4.20718 21.2071L2.79297 19.7928L10.5859 12Z"
          ></path>
          <path
            v-else
            d="M3 4H21V6H3V4ZM3 11H15V13H3V11ZM3 18H21V20H3V18Z"
          ></path>
        </svg>
      </button>

      <nav
        class="flex gap-40 mobile"
        :style="{
          maxHeight: showMobileMenu ? '100vh' : '0px',
          paddingTop: showMobileMenu ? '20px' : '0px',
          paddingBottom: showMobileMenu ? '20px' : '0px',
        }"
      >
        <router-link
          @click="showMobileMenu = false"
          to="/#welcome"
          class="header-btn"
          >Home</router-link
        >

        <button
          class="header-btn"
          @click="showDiscoverSubmenuMobile = !showDiscoverSubmenuMobile"
        >
          Discover
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path
              d="M12 15.0006L7.75732 10.758L9.17154 9.34375L12 12.1722L14.8284 9.34375L16.2426 10.758L12 15.0006Z"
            ></path>
          </svg>
        </button>
        <div class="submenu" v-if="showDiscoverSubmenuMobile">
          <div class="button-bg">
            <router-link @click="showMobileMenu = false" to="/#features"
              >Features</router-link
            >
          </div>
          <div class="button-bg">
            <router-link @click="showMobileMenu = false" to="/#solutions"
              >Solutions</router-link
            >
          </div>
          <div class="button-bg">
            <router-link @click="showMobileMenu = false" to="/#products"
              >Products</router-link
            >
          </div>
          <div class="button-bg">
            <router-link @click="showMobileMenu = false" to="/#team"
              >Team</router-link
            >
          </div>
        </div>

        <button
          class="header-btn"
          @click="showPagesSubmenuMobile = !showPagesSubmenuMobile"
        >
          Pages
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path
              d="M12 15.0006L7.75732 10.758L9.17154 9.34375L12 12.1722L14.8284 9.34375L16.2426 10.758L12 15.0006Z"
            ></path>
          </svg>
        </button>
        <div class="submenu" v-if="showPagesSubmenuMobile">
          <div class="button-bg">
            <router-link @click="showMobileMenu = false" to="/about"
              >About Us</router-link
            >
          </div>
          <div class="button-bg">
            <router-link @click="showMobileMenu = false" to="/features"
              >Features</router-link
            >
          </div>
          <div class="button-bg">
            <router-link @click="showMobileMenu = false" to="/faq"
              >FAQ</router-link
            >
          </div>
          <div class="button-bg">
            <router-link @click="showMobileMenu = false" to="/blog"
              >Blog</router-link
            >
          </div>
        </div>

        <router-link
          @click="showMobileMenu = false"
          to="/contact"
          class="header-btn"
          >Contact</router-link
        >
        <router-link
          @click="showMobileMenu = false"
          to="/products"
          class="btn-1 margin-la"
          style="justify-content: center"
          >Products</router-link
        >
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: "HeaderComponent",
  props: {
    scrollTop: Number,
  },
  data() {
    return {
      showDiscoverSubmenu: false,
      showPagesSubmenu: false,
      showMobileMenu: false,
      showDiscoverSubmenuMobile: false,
      showPagesSubmenuMobile: false,
      getYScroll: 0,
    };
  },
};
</script>

<style scoped>
.menu-btn svg {
  width: 100%;
  height: 100%;
}
.menu-btn {
  width: 30px;
  height: 30px;
  padding: 0px;
  margin-left: auto;
}
.submenu-enter-active,
.submenu-leave-active {
  transition: all 0.3s ease;
}

.submenu-enter-from,
.submenu-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}

.submenu-enter-to,
.submenu-leave-from {
  opacity: 1;
  transform: translateY(0);
}

.submenu button:hover,
.submenu a:hover {
  background-color: #f5f5f5;
  left: 3px;
}

.submenu .button-bg {
  background-color: rgb(var(--m-color));
  position: relative;
  height: 40px;
}

.submenu button,
.submenu a {
  padding: 0px;
  display: block;
  background: #fff;
  color: #3b566e;
  padding-left: 20px;
  line-height: 40px;
  transition: all 0.3s ease;
  position: relative;
  font-size: 13px;
  border-bottom: 1px solid #f5f5f5;
  text-align: start;
  font-weight: 600;
  font-size: 14px;
  position: absolute;
  top: 0px;
  left: 0px;
  height: 40px;
  width: 100%;
}

.submenu {
  display: grid;
  position: absolute;
  width: 200px;
  border-radius: 6px;
  z-index: 1;
  top: 40px;
  box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.06);
}

.header-btn svg {
  width: 20px;
  height: 20px;
}

.header-btn {
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  color: #6f8ba4;
  transition: all 0.3s ease;
  height: 40px;
  line-height: 40px;
  border: transparent;
  letter-spacing: 1px;
  position: relative;
}

nav {
  margin-left: 80px;
}

.logo {
  width: max-content;
  height: 30px;
}

.sticky-header {
  background: #fff;
  height: 70px;
  box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.06);
}

header {
  position: sticky;
  top: 0px;
  left: 0px;
  right: 0px;
  z-index: 100;
  height: 70px;
  transition: all 0.3s ease;
  display: flex;
  justify-content: center;
}

.container {
  display: flex;
  align-items: center;
  position: relative;
}

.logo-box {
  display: flex;
  gap: 5px;
  align-items: center;
  cursor: pointer;
}

.mobile {
  display: none;
}

button {
  padding: 0px;
}
@media (max-width: 800px) {
  button {
    width: 100%;
  }
  .no-mobile {
    display: none;
  }
  .mobile {
    display: block;
  }
  nav {
    margin: 0px;
    position: absolute;
    top: 70px;
    left: 0px;
    width: calc(100% - 40px);
    background: white;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    overflow: hidden;
    padding: 0px 20px;
  }
  nav .header-btn {
    color: #212121;
    font-size: 16px;
  }
  .submenu {
    position: unset;
    width: calc(100% - 20px);
    box-shadow: none;
  }
}
</style>
